import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { OriginalRow } from 'components/Table';
import { AP2OptionsList, ConfiguratorState, OptionAT } from 'models/configurator';
import { MicroCategory, WfCasual, WfDefinition } from 'models/request';
import {
  AP2Template,
  CompanyActionTable,
  CorporateApproval,
  GetNopoMicrocategoriesResponse,
  GetNopoVendorResponse,
  PoMicroCategoryList,
  PoVendorList,
  Subject,
  VendorNoPoList,
} from 'models/response';

const setActionTablesView: CaseReducer<ConfiguratorState, PayloadAction<{ value: string; label: string } | null>> = (
  state,
  { payload },
) => {
  state.actionTables.selectedView = payload;
};

const setSelectedTableToSearch: CaseReducer<ConfiguratorState, PayloadAction<string>> = (state, { payload }) => {
  state.actionTables.selectedTableToSearch = payload;
};

const setATCompanies: CaseReducer<ConfiguratorState, PayloadAction<CompanyActionTable[]>> = (state, { payload }) => {
  state.actionTables.companies = payload;
};

const setSelectedAtCompanies: CaseReducer<ConfiguratorState, PayloadAction<CompanyActionTable[]>> = (
  state,
  { payload },
) => {
  state.actionTables.selectedCompanies = payload;
};

const setLeftTableRows: CaseReducer<ConfiguratorState, PayloadAction<PoMicroCategoryList[] | PoVendorList[]>> = (
  state,
  { payload },
) => {
  state.actionTables.leftTableRows = payload;
};

const setSelectedRow: CaseReducer<ConfiguratorState, PayloadAction<PoMicroCategoryList | PoVendorList | null>> = (
  state,
  { payload },
) => {
  state.actionTables.selectedRow = payload;
};

const setSelectedOptionValue: CaseReducer<ConfiguratorState, PayloadAction<OptionAT[]>> = (state, { payload }) => {
  state.actionTables.selectedOptionValue = payload;
};

const setEditedRowId: CaseReducer<ConfiguratorState, PayloadAction<string | undefined>> = (state, { payload }) => {
  state.actionTables.editedRowId = payload;
};

const setWfCasuals: CaseReducer<ConfiguratorState, PayloadAction<WfCasual[]>> = (state, { payload }) => {
  state.actionTables.wfCasuals = payload;
};

const setWfDefinitions: CaseReducer<ConfiguratorState, PayloadAction<WfDefinition[]>> = (state, { payload }) => {
  state.actionTables.wfDefinitions = payload;
};

const setCorporateApprovalList: CaseReducer<ConfiguratorState, PayloadAction<CorporateApproval[]>> = (
  state,
  { payload },
) => {
  state.actionTables.corporateApproval.corporateApprovalList = payload;
};

const setSelectedCorporateApproval: CaseReducer<ConfiguratorState, PayloadAction<CorporateApproval | null>> = (
  state,
  { payload },
) => {
  state.actionTables.corporateApproval.selectedRow = payload;
};

const setEditRowIdCorporateApproval = (state: ConfiguratorState, { payload }: PayloadAction<string | undefined>) => {
  state.actionTables.corporateApproval.editRowId = payload;
};
const setAllSubject: CaseReducer<ConfiguratorState, PayloadAction<Subject[]>> = (state, { payload }) => {
  state.actionTables.allSubjects = payload;
};

const setAllMicroCategories: CaseReducer<ConfiguratorState, PayloadAction<MicroCategory[]>> = (state, { payload }) => {
  state.actionTables.allMicroCategories = payload;
};

const setOptionValueDropdown: CaseReducer<ConfiguratorState, PayloadAction<OptionAT[]>> = (state, { payload }) => {
  state.actionTables.optionValueDropdown = payload;
};

const setOptionDescriptionDropdown: CaseReducer<ConfiguratorState, PayloadAction<OptionAT[]>> = (
  state,
  { payload },
) => {
  state.actionTables.optionDescriptionDropdown = payload;
};

const setAP2OptionList: CaseReducer<ConfiguratorState, PayloadAction<AP2OptionsList>> = (state, { payload }) => {
  state.actionTables.AP2OptionsList = payload;
};

const setNotModifiedRow: CaseReducer<
  ConfiguratorState,
  PayloadAction<PoMicroCategoryList | PoVendorList | undefined>
> = (state, { payload }) => {
  state.actionTables.notModifiedRow = payload;
};

const setSelectedAP2row: CaseReducer<ConfiguratorState, PayloadAction<AP2Template | null>> = (state, { payload }) => {
  state.actionTables.selectedAP2row = payload;
};

const setEditedRowAP2ID: CaseReducer<ConfiguratorState, PayloadAction<number | null>> = (state, { payload }) => {
  state.actionTables.editedRowAP2ID = payload;
};

const setIsEditAP2Template: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.actionTables.isEditAP2Template = payload;
};

const setTemplateAP2List: CaseReducer<ConfiguratorState, PayloadAction<OriginalRow[]>> = (state, { payload }) => {
  state.actionTables.templateAP2List = payload;
};

const setIsAddP2Template: CaseReducer<ConfiguratorState, PayloadAction<boolean>> = (state, { payload }) => {
  state.actionTables.isAddAP2Template = payload;
};

const setVendorListAp2Template: CaseReducer<ConfiguratorState, PayloadAction<VendorNoPoList[]>> = (
  state,
  { payload },
) => {
  state.actionTables.vendorListAp2Template = payload;
};

const setNoPoEditedRowId: CaseReducer<ConfiguratorState, PayloadAction<string | undefined>> = (state, { payload }) => {
  state.actionTables.NOPO.editedRowId = payload;
};

const setNoPoLeftTableRows: CaseReducer<
  ConfiguratorState,
  PayloadAction<GetNopoVendorResponse[] | GetNopoMicrocategoriesResponse[]>
> = (state, { payload }) => {
  state.actionTables.NOPO.leftTableRows = payload;
};

const setNoPoSelectedRow: CaseReducer<
  ConfiguratorState,
  PayloadAction<GetNopoVendorResponse | GetNopoMicrocategoriesResponse | null>
> = (state, { payload }) => {
  state.actionTables.NOPO.selectedRow = payload;
};

const setNopoNotModifiedRow: CaseReducer<
  ConfiguratorState,
  PayloadAction<GetNopoVendorResponse | GetNopoMicrocategoriesResponse | undefined>
> = (state, { payload }) => {
  state.actionTables.NOPO.notModifiedRow = payload;
};

export default {
  setActionTablesView,
  setSelectedTableToSearch,
  setATCompanies,
  setSelectedAtCompanies,
  setLeftTableRows,
  setSelectedRow,
  setSelectedOptionValue,
  setCorporateApprovalList,
  setSelectedCorporateApproval,
  setAP2OptionList,
  setEditedRowId,
  setWfCasuals,
  setWfDefinitions,
  setAllSubject,
  setAllMicroCategories,
  setOptionValueDropdown,
  setOptionDescriptionDropdown,
  setNotModifiedRow,
  setSelectedAP2row,
  setEditedRowAP2ID,
  setIsEditAP2Template,
  setTemplateAP2List,
  setIsAddP2Template,
  setVendorListAp2Template,
  setEditRowIdCorporateApproval,
  setNoPoEditedRowId,
  setNoPoLeftTableRows,
  setNoPoSelectedRow,
  setNopoNotModifiedRow,
};
